import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { ReactNode } from "react";

interface FilterContainerProps {
  title: string;
  description: string;
  children: ReactNode;
  action?: ReactNode;
}

export function FilterContainer({
  title,
  description,
  children,
  action,
}: FilterContainerProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <CardTitle className="text-lg sm:text-xl">{title}</CardTitle>
            <CardDescription className="text-sm">{description}</CardDescription>
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-3 items-end">
          {children}
        </div>
      </CardContent>
    </Card>
  );
}
